import React from "react";
import { Progress } from "@mantine/core";

const LabeledLinearProgressMeter = (props) => {
	return (
		<div>
			<div style={{ display: "flex" }}>
				<div>{props.label}</div>
				<div
					style={{
						marginLeft: "auto",
						width: 300,
						paddingTop: 8,
					}}
				>
					<Progress
						size={4}
						value={Math.min(Math.max(0, props.progress), 100)}
					/>
				</div>
			</div>
			{props.description && (
				<div style={{ marginTop: 8 }}>{props.description}</div>
			)}
		</div>
	);
};
const MultipleLinearProgressMetersWithLabel = (props) => {
	return (
		<div style={props.style}>
			<div
				className="MainFontBold"
				style={{
					borderBottom: "1px solid",
					borderColor: "var(--lw-dark-grey)",
					marginBottom: 16,
					paddingBottom: 8,
				}}
			>
				{props.topLabel}
			</div>
			<div style={{ width: 400 }}>
				{props.meters.map(({ label, progress, description }, index) => (
					<div key={index} style={{ marginBottom: 12 }}>
						<LabeledLinearProgressMeter
							label={label}
							description={description}
							progress={progress}
						/>
					</div>
				))}
			</div>
		</div>
	);
};

const SemiCircleProgressMeter = ({ progress, label }) => {
	const r = 60;
	const strokeWidth = 12;
	const cx = r + strokeWidth / 2;
	const cy = r + strokeWidth / 2;
	const circumference = 2 * Math.PI * r;
	const halfCircumference = Math.PI * r;
	const clampedProgress = Math.min(Math.max(0, progress), 100);
	const progressArc = (clampedProgress / 100) * halfCircumference;
	const maxWidth = r * 2 + strokeWidth;

	return (
		<div
			style={{
				display: "inline-flex",
				flexDirection: "column",
				alignItems: "center",
				maxWidth: maxWidth,
			}}
		>
			<svg width={cx * 2} height={cy} viewBox={`0 0 ${cx * 2} ${cy}`}>
				<circle
					cx={cx}
					cy={cy}
					r={r}
					fill="none"
					stroke="#dee2e6"
					strokeWidth={strokeWidth}
					strokeDasharray={`${halfCircumference} ${circumference}`}
					transform={`rotate(180, ${cx}, ${cy})`}
					strokeLinecap="round"
				/>
				<circle
					cx={cx}
					cy={cy}
					r={r}
					fill="none"
					stroke={"var(--lxw-main-500)"}
					strokeWidth={strokeWidth}
					strokeDasharray={`${progressArc} ${circumference}`}
					transform={`rotate(180, ${cx}, ${cy})`}
					strokeLinecap="round"
				/>
				<text
					x={cx}
					y={cy - 4}
					textAnchor="middle"
					fontSize={14}
					fontWeight="bold"
					fill="currentColor"
				>
					{Math.round(clampedProgress)}%
				</text>
			</svg>
			{label && (
				<div
					style={{
						marginTop: 4,
						fontSize: 13,
						textAlign: "center",
					}}
				>
					{label}
				</div>
			)}
		</div>
	);
};

export default LabeledLinearProgressMeter;
export { MultipleLinearProgressMetersWithLabel, SemiCircleProgressMeter };
